import { InputBase, styled } from "@mui/material";

export const SearchInput = styled(InputBase)({
  flex: 1,
  width: "100%",
  "& input": {
    fontSize: "15px",
    color: "#111b21",
    padding: "8px 0",
    width: "100%",
    "&::placeholder": {
      color: "#667781",
    },
  },
});
